import { render, staticRenderFns } from "./Oneclick.vue?vue&type=template&id=30b5b7e4&scoped=true&"
import script from "./Oneclick.vue?vue&type=script&lang=js&"
export * from "./Oneclick.vue?vue&type=script&lang=js&"
import style0 from "./Oneclick.vue?vue&type=style&index=0&id=30b5b7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b5b7e4",
  null
  
)

export default component.exports